(() => {
  const initialize = () => {
    const root = document.getElementById('mp-reta');
    if (root && !root.dataset.navigationReady) {
      root.dataset.navigationReady = 'true';
      root.addEventListener('click', event => {
        const link = event.target.closest('a[href^="#mp-reta-"]');
        if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const target = document.getElementById(link.hash.slice(1));
        if (!target) return;
        event.preventDefault();
        event.stopPropagation();
        target.scrollIntoView({behavior: 'instant', block: 'start'});
        target.setAttribute('tabindex', '-1');
        target.focus({preventScroll: true});
      });
    }
    if (root && !root.dataset.mobileFlowReady) {
      root.dataset.mobileFlowReady = 'true';
      const links = Array.from(root.querySelectorAll('[data-section-link]'));
      const sections = links.map(link => document.getElementById(link.hash.slice(1)));
      const shop = root.querySelector('#mp-reta-shop');
      const final = root.querySelector('.mpr-final');
      const sticky = root.querySelector('[data-mpr-sticky]');
      const mobile = window.matchMedia('(max-width: 749px)');
      let queued = false;
      const updateFlow = () => {
        queued = false;
        let current = 0;
        sections.forEach((section, index) => {
          if (section && section.getBoundingClientRect().top < 200) current = index;
        });
        links.forEach((link, index) => {
          link.classList.toggle('is-current', index === current);
          if (index === current) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        });
        if (sticky && shop && final) {
          sticky.hidden = !(mobile.matches && shop.getBoundingClientRect().bottom < 100 && final.getBoundingClientRect().top > window.innerHeight);
        }
      };
      const scheduleFlow = () => {
        if (queued) return;
        queued = true;
        window.requestAnimationFrame(updateFlow);
      };
      window.addEventListener('scroll', scheduleFlow, {passive: true});
      window.addEventListener('resize', scheduleFlow, {passive: true});
      window.addEventListener('pageshow', scheduleFlow);
      updateFlow();
    }
    const form = document.getElementById('mpr-kit-form');
    if (!form || form.dataset.initialized) return;
    form.dataset.initialized = 'true';
    const button = form.querySelector('[data-kit-add]');
    const quantity = form.querySelector('[name="quantity"]');
    const update = () => {
      const option = form.querySelector('[name="id"]:checked');
      if (!option) return;
      form.querySelector('[data-kit-price]').textContent = option.dataset.price;
      form.querySelector('[data-kit-total]').textContent = option.dataset.detail;
      form.querySelector('[data-kit-unit]').textContent = option.dataset.unit;
      const available = option.dataset.available === 'true';
      button.disabled = !available;
      const status = root.querySelector('[data-kit-status]');
      if (status) {
        status.classList.toggle('is-ready', available);
        status.textContent = available ? status.dataset.readyLabel : status.dataset.unavailableLabel;
      }
      form.querySelector('[data-kit-add-label]').textContent = available ? button.dataset.addLabel : button.dataset.unavailableLabel;
      quantity.min = option.dataset.min;
      quantity.step = option.dataset.step;
      if (option.dataset.max) quantity.max = option.dataset.max;
      else quantity.removeAttribute('max');
      if (!quantity.checkValidity()) quantity.value = quantity.min;
    };
    form.addEventListener('change', event => {
      if (event.target.name === 'id') update();
    });
    form.addEventListener('submit', event => {
      update();
      if (button.disabled || !form.checkValidity()) {
        event.preventDefault();
        form.reportValidity();
      }
    });
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
  window.addEventListener('pageshow', initialize);
})();
